<template>
  <div class="page-content">
    <LiveTasks />
    <CompletedTasks />
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent, nextTick, onMounted } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

const RequestAlert = defineAsyncComponent(() => import('./OperatorAlerts/RequestAlert.vue'));
const LiveTasks = defineAsyncComponent(() => import('./OperatorAlerts/LiveTasks.vue'));
const CompletedTasks = defineAsyncComponent(() => import('./OperatorAlerts/CompletedTasks.vue'));

onMounted(async () => {
  const route = useRoute();
  const hash = route.hash;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>
